import styled from "styled-components"
import { T } from "../../styles/typography"
import Breakpoints from "../../../components/shared/breakpoints"

export const LightboxWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000000a0;
  z-index: 1000;
  backdrop-filter: blur(10px);
`

export const LightboxControls = styled.div`
  width: calc(100% - 2 * 16px);
  background-color: #000000;
  opacity: 0.85;
  display: flex;
  align-items: center;
  padding: 16px;
  justify-content: flex-end;

  & > button {
    ${T.sm.h4`500`}
    color: #fff;
    border: 1px solid white;
    padding: 8px 16px;
    background-color: #ffffff00;
    cursor: pointer;
  }
`

export const LightboxContentWrapper = styled.div`
  padding: 0 10vw;
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 75px);

  & .slick-slider,
  & > * {
    width: 100%;
    max-width: 875px;
  }

  & .slick-prev {
    transform: translate3d(-10px, 0, 0);
  }
  & .slick-next {
    transform: translate3d(10px, 0, 0);
  }

  @media (min-width: ${Breakpoints.md}) {
    padding: 0 20vw;
  }
`
